// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"41":"EditInvoice","241":"Payments","264":"CreateInvoice","998":"chunk-vendors"}[chunkId] || chunkId) + "." + {"41":"b20ae04a","241":"060ca320","264":"b20ae04a","918":"b4e58712","998":"25f5475d"}[chunkId] + ".css";
};